import React, { memo, forwardRef, useState, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import "./DatePickerInput.css";
import ReactInputMask from "react-input-mask";
import { formatDDMMYYYY, formatDate } from "../../../common/utils";
import { languageSelector } from "../../../features/language/languageSlice";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffect } from "react";
import {
  FintracDOBDOIStandardQuestionName,
  OriginalTransferDateStandardQuestionName,
} from "../../../common/constants";

var TodaysDate = new Date();
var dd = String(TodaysDate.getDate()).padStart(2, "0");
var mm = String(TodaysDate.getMonth() + 1).padStart(2, "0");
var yyyy = TodaysDate.getFullYear();
TodaysDate = mm + "/" + dd + "/" + yyyy;

/* ---------------------------- NEW: DATE NORMALIZER ---------------------------- */
const normalizeDate = (value) => {
  if (!value) return null;

  // Already a valid Date object
  if (value instanceof Date && !isNaN(value)) return value;

  // Native parser for formats like: "Sun Nov 30 2025 GMT+0500"
  if (typeof value === "string") {
    return new Date(value);
  }

  // Fallback manual parser for formats like DD/MM/YYYY or DD-MM-YYYY
  // const regex = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/;

  // const match = value.match(regex);
  // if (match) {
  //   const [_, d, m, y] = match;
  //   return new Date(y, m - 1, d);
  // }

  return null; // default
};

// Utility function to format date as MM/DD/YYYY
const formatMMDDYYYY = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
/* ------------------------------------------------------------------------------ */

function DatePickerInput(props) {
  registerLocale("fr", fr);
  const [startDate, setStartDate] = useState(
    props.disabled ? new Date() : null,
  );
  const inputRef = useRef(null);
  const lang = useSelector(languageSelector);

  // Check if we should use MM/DD/YYYY format
  const useMMDDYYYY = false; // FintracDOBDOIStandardQuestionName?.includes(props.standardQuestionName);
  useEffect(() => {
    setStartDate(normalizeDate(props.value));
  }, [props.value]);

  return (
    <>
      <div>
        {props.value ? (
          <DatePicker
            locale={lang?.value === "fr" ? "fr" : ""}
            maxDate={
              OriginalTransferDateStandardQuestionName?.includes(
                props.standardQuestionName,
              ) || props.quoteTransferDate
                ? new Date() // disables future dates, allows today
                : FintracDOBDOIStandardQuestionName?.includes(
                      props.standardQuestionName,
                    )
                  ? new Date(new Date().getTime() - 24 * 60 * 60 * 1000) // yesterday (strictly past)
                  : null
            } // disables future dates
            customInput={
              <CustomInput
                dynamicPicker={props.dynamicPicker}
                inputRef={inputRef}
                value={
                  normalizeDate(props.value)
                    ? useMMDDYYYY
                      ? formatMMDDYYYY(normalizeDate(props.value))
                      : formatDDMMYYYY(normalizeDate(props.value))
                    : ""
                }
                typeDate={(date) => {
                  props.field.onChange(date);
                  if (props.trigger) {
                    props.trigger(props.fieldName);
                  }
                }}
                disabled={props.disabled || props.loading}
                testId={props?.testId || ""}
                Mandatory={props.Mandatory}
                trigger={props.trigger}
                fieldName={props.fieldName}
                closeFilter={props.closeFilter ? props.closeFilter : null}
                setisDateFilterApplied={props.setisDateFilterApplied}
                isDateFilterApplied={props.isDateFilterApplied}
                isOrderStatus={props.isOrderStatus}
                useMMDDYYYY={useMMDDYYYY}
                standardQuestionName={props.standardQuestionName}
                quoteTransferDate={props.quoteTransferDate}
              />
            }
            className={
              "custom__datepicker bg-white border w-full p-2.5" +
              (props.Mandatory ? " Mandatory" : "")
            }
            placeholderText={TodaysDate}
            onChange={(date) => {
              const formattedValue =
                // props.isDynamicQuestion
                //   ?
                date?.toString();
              // : date;

              if (props.handleChange) {
                props.handleChange(formattedValue, props.field.name);
              }

              if (props.field.onChange) {
                props.field.onChange(formattedValue);
              }

              if (!props.onChange) {
                setStartDate(date);
              } else {
                props.onChange(formattedValue);
              }

              if (props.trigger) {
                props.trigger(props.fieldName);
              }

              if (props.closeFilter) {
                props.closeFilter();
              }
            }}
            value={normalizeDate(props.value)}
            selected={
              props.onChange
                ? normalizeDate(props.value)
                : normalizeDate(startDate)
            }
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            dayClassName={(date) => (date ? "datepicker-cell" : "")}
            type="date"
            dateFormat={useMMDDYYYY ? "MM/dd/yyyy" : "dd/MM/yyyy"}
            disabled={props.disabled || props.loading}
          />
        ) : (
          <DatePicker
            locale={lang?.value === "fr" ? "fr" : ""}
            maxDate={
              OriginalTransferDateStandardQuestionName?.includes(
                props.standardQuestionName,
              ) || props.quoteTransferDate
                ? new Date() // disables future dates, allows today
                : FintracDOBDOIStandardQuestionName?.includes(
                      props.standardQuestionName,
                    )
                  ? new Date(new Date().getTime() - 24 * 60 * 60 * 1000) // yesterday (strictly past)
                  : null
            } // disables future dates
            customInput={
              <CustomInput
                dynamicPicker={props.dynamicPicker}
                inputRef={inputRef}
                typeDate={(date) => {
                  props.field.onChange(date);
                  if (props.trigger) {
                    props.trigger(props.fieldName);
                  }
                  if (props.closeFilter) {
                    props.closeFilter();
                  }
                }}
                disabled={props.disabled || props.loading}
                testId={props.testId || ""}
                Mandatory={props.Mandatory}
                trigger={props.trigger}
                fieldName={props.fieldName}
                setisDateFilterApplied={props.setisDateFilterApplied}
                isDateFilterApplied={props.isDateFilterApplied}
                isOrderStatus={props.isOrderStatus}
                useMMDDYYYY={useMMDDYYYY}
                standardQuestionName={props.standardQuestionName}
                quoteTransferDate={props.quoteTransferDate}
              />
            }
            className="custom__datepicker bg-white border w-full p-2.5"
            placeholderText={TodaysDate}
            onChange={(date) => {
              setStartDate(date);
              const formattedValue =
                // props.isDynamicQuestion
                //   ?
                date?.toString();
              // : date;
              if (props.handleChange) {
                props.handleChange(formattedValue, props.field.name);
              }
              if (props.field.onChange) {
                props.field.onChange(formattedValue);
              }
              if (props.trigger) {
                props.trigger(props.fieldName);
              }
            }}
            selected={
              props.fieldName === "ClosingDateFilter"
                ? null
                : normalizeDate(startDate)
            }
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            dayClassName={(date) => (date ? "datepicker-cell" : "")}
            disabled={props.disabled || props.loading}
            type="date"
            dateFormat={useMMDDYYYY ? "MM/dd/yyyy" : "dd/MM/yyyy"}
          />
        )}
      </div>

      {props?.dateRange && (
        <div
          className="flex flex-row items-center pl-1 mt-2"
          aria-labelledby="date_range"
          role="application"
        >
          <input
            id="date_range"
            type="checkbox"
            value="date range"
            name="date_range"
            className="custom__checkbox custom__checkbox-multiple h-4 pl-2 relative w-4"
            onChange={() => props.setDatePicker((prev) => !prev)}
            checked={props.datepicker}
          />
          <label for="date_range" className="font-normal ml-2">
            Date Range
          </label>
        </div>
      )}
    </>
  );
}

export default memo(DatePickerInput);

export const CustomInput = forwardRef(
  (
    {
      value,
      onClick,
      onFocus,
      onChange,
      dynamicPicker,
      typeDate,
      disabled,
      testId,
      Mandatory,
      trigger,
      fieldName,
      closeFilter,
      setisDateFilterApplied,
      isDateFilterApplied,
      isOrderStatus = false,
      useMMDDYYYY = false,
      standardQuestionName,
      quoteTransferDate,
    },
    ref,
  ) => {
    // Local state to manage input text as user types
    const [inputText, setInputText] = useState(value || "");

    // Update local state when external value changes
    useEffect(() => {
      setInputText(value || "");
    }, [value]);

    const handleInputChange = (e) => {
      const inputValue = e.target.value;
      setInputText(inputValue);

      const isEmpty = inputValue.replace(/[\s/]/g, "") === "";
      if (isEmpty) {
        typeDate(null);
        closeFilter && closeFilter();
        trigger && trigger(fieldName);
        return;
      }

      const dateFormatRegex = useMMDDYYYY
        ? /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/
        : /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

      if (dateFormatRegex.test(inputValue)) {
        const parts = inputValue.split("/");
        let jsDate;

        if (useMMDDYYYY) {
          const [month, day, year] = parts;
          jsDate = new Date(year, month - 1, day);
        } else {
          const [day, month, year] = parts;
          jsDate = new Date(year, month - 1, day);
        }

        let maxDate = null;
        if (
          OriginalTransferDateStandardQuestionName?.includes(
            standardQuestionName,
          ) ||
          quoteTransferDate
        ) {
          maxDate = new Date();
        } else if (
          FintracDOBDOIStandardQuestionName?.includes(standardQuestionName)
        ) {
          maxDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        }

        if (maxDate && jsDate > maxDate) {
          setInputText("");
          typeDate(null);
        } else if (!isNaN(jsDate)) {
          typeDate(jsDate);
        } else {
          typeDate(null);
        }
      } else {
        typeDate(null);
      }

      closeFilter && closeFilter();
      trigger && trigger(fieldName);
    };

    useEffect(() => {
      if (isOrderStatus) {
        if (value !== null && value?.trim()?.length > 6)
          setisDateFilterApplied(true);
      }
    }, [value]);

    return (
      <>
        <div
          className={
            dynamicPicker
              ? `flex flex-row w-[200px] select-container ${
                  isDateFilterApplied ? "filter-applied" : ""
                }`
              : `flex flex-row select-container ${
                  isDateFilterApplied ? "filter-applied" : ""
                }`
          }
        >
          <div
            className={
              dynamicPicker
                ? "datepicker relative w-[250px]"
                : "datepicker relative"
            }
          >
            <ReactInputMask
              type="text"
              className={`custom__datepicker bg-white border w-full p-2.5 ${
                Mandatory ? "Mandatory" : ""
              }`}
              placeholder={useMMDDYYYY ? "mm/dd/yyyy" : "dd/mm/yyyy"}
              onClick={onClick}
              onFocus={() => {}}
              onChange={handleInputChange}
              value={inputText}
              ref={ref}
              mask="99/99/9999"
              maskChar={" "}
              dateFormat={useMMDDYYYY ? "MM/dd/yyyy" : "dd/MM/yyyy"}
              disabled={disabled}
              data-cy={testId || ""}
              name={fieldName}
              standardQuestionName={standardQuestionName}
            />

            <div className="datepicker__icon absolute inset-y-0 left-0 flex items-center pointer-events-none">
              <svg
                aria-hidden="true"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2142_5044)">
                  <path
                    d="M13.7979 2.48755H3.02058C2.17027 2.48755 1.48096 3.14881 1.48096 3.96451V14.3032C1.48096 15.1189 2.17027 15.7802 3.02058 15.7802H13.7979C14.6482 15.7802 15.3375 15.1189 15.3375 14.3032V3.96451C15.3375 3.14881 14.6482 2.48755 13.7979 2.48755Z"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M11.4888 1.0105V3.96442"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M5.33008 1.0105V3.96442"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M1.48096 6.91846H15.3375"
                    stroke="#595959"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_2142_5044">
                    <path
                      d="M0 1C0 0.447715 0.447715 0 1 0H16.4091V16.7907H0.999999C0.447714 16.7907 0 16.343 0 15.7907V1Z"
                      fill="white"
                    ></path>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  },
);
